
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/[slug]",
      function () {
        return require("private-next-pages/homes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homes/[slug]"])
      });
    }
  